import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "border p-2 mb-2 d-flex flex-column forms__summary-item"
};
const _hoisted_2 = { style: { "width": "30px" } };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 1,
    class: "text-success"
};
const _hoisted_5 = {
    key: 2,
    class: "text-warning"
};
const _hoisted_6 = {
    key: 3,
    class: "text-warning"
};
const _hoisted_7 = { style: { "width": "50px" } };
const _hoisted_8 = { class: "flex-fill" };
const _hoisted_9 = {
    key: 0,
    style: { "width": "30px" },
    class: "text-center"
};
const _hoisted_10 = { class: "expand-icon" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("g", null, [
    /*#__PURE__*/ _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
], -1);
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = { style: { "padding-left": "30px", "padding-right": "10px" } };
const _hoisted_14 = { class: "alert alert-danger mt-2 mb-0 p-2 small" };
const _hoisted_15 = {
    key: 0,
    class: "content",
    style: { "padding-left": "30px", "padding-right": "10px" }
};
const _hoisted_16 = { class: "d-block mt-2" };
const _hoisted_17 = { class: "container p-0 m-0" };
const _hoisted_18 = { class: "container p-0 m-0 mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_button = _resolveComponent("g-button");
    return (_ctx.page.pageType === 'data')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(['title d-flex flex-row fw-bold', _ctx.page.isEnabled ? '' : 'text-muted'])
            }, [
                _createElementVNode("div", _hoisted_2, [
                    (!_ctx.page.isEnabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_g_icon, {
                                width: "16",
                                height: "16",
                                src: "/assets/icons/lock.svg"
                            })
                        ]))
                        : (_ctx.page.validationState === 'succeeded')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/check-circle-fill.svg"
                                })
                            ]))
                            : (_ctx.page.validationState === 'none')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                                : (_ctx.page.validationState)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createVNode(_component_g_icon, {
                                            width: "16",
                                            height: "16",
                                            src: "/assets/icons/exclamation-triangle.svg"
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.page.titleNumber), 1),
                _createElementVNode("div", _hoisted_8, [
                    (_ctx.page.isEnabled)
                        ? (_openBlock(), _createBlock(_component_g_link, {
                            key: 0,
                            onLinkClick: _ctx.onExpand
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.page.title), 1)
                            ]),
                            _: 1
                        }, 8, ["onLinkClick"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.page.title), 1)
                        ], 64))
                ]),
                (_ctx.page.pageType === 'data' && _ctx.page.isEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_g_link, { onLinkClick: _ctx.onExpand }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, [
                                    (_openBlock(), _createElementBlock("svg", {
                                        class: _normalizeClass([_ctx.isOpen ? 'expand-icon__opened' : 'expand-icon__closed']),
                                        height: "1em",
                                        width: "1em",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        stroke: "currentColor"
                                    }, _hoisted_12, 2))
                                ])
                            ]),
                            _: 1
                        }, 8, ["onLinkClick"])
                    ]))
                    : _createCommentVNode("", true)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$forms.getAllErrorMessages(_ctx.page), (message) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(message.text), 1)
                ]));
            }), 256)),
            (_ctx.isOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.content, (tContent) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: tContent.member
                                }, [
                                    (_ctx.$forms.isVisible(tContent, _ctx.$forms.getDataForEval(_ctx.schema, _ctx.data, _ctx.page)))
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$forms.componentSummaryName(tContent.elementType)), {
                                            key: 0,
                                            schema: _ctx.schema,
                                            content: tContent,
                                            data: _ctx.data,
                                            "schema-data": _ctx.schemaData
                                        }, null, 8, ["schema", "content", "data", "schema-data"]))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_g_button, {
                                "button-style": "btn-outline-secondary btn-sm",
                                text: "Zur Eingabe / Seite wechseln",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onCommand('page-goto', { page: _ctx.page })))
                            })
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
        ]))
        : _createCommentVNode("", true);
}
